<template>
  <base-create-form
    :create-form="createForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-create-form>
</template>

<script>
import { BaseCreateForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import { ProgramCriterionService } from "../../../services/programCriterion.service";
import { ProgramCriterionCategoriesService } from "../../../services/programCriterionCategories.service";
export default {
  name: "ProgramCriterionCreateForm",
  components: { BaseCreateForm },
  data() {
    return {
      formTitle: this.$t("page_title.program_criterion_create"),
      createForm: [
        {
          label: this.$t("program_criterion.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("program_criterion.category_name"),
          name: "criterion_category_id",
          value: "",
          type: "select",
          options: [],
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("program_criterion.description"),
          name: "description",
          value: "",
          type: "textarea",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "ProgramCriterionList" });
    },
    async submitForm(params) {
      const response = await new ProgramCriterionService().create(params);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("program_criterion.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(
        () => this.$router.push({ name: "ProgramCriterionList" }),
        500
      );
    },
    async getCriterionCategories() {
      const response = await new ProgramCriterionCategoriesService().getList({
        limit: 1000
      });
      this.createForm[1].options = response.data || [];
      return response.data;
    }
  },
  created() {
    this.getCriterionCategories();
  }
};
</script>

<style scoped></style>
